import { render, staticRenderFns } from "./CopyMoveCalendarModal.vue?vue&type=template&id=96c5a64c&scoped=true"
import script from "./CopyMoveCalendarModal.vue?vue&type=script&lang=js"
export * from "./CopyMoveCalendarModal.vue?vue&type=script&lang=js"
import style0 from "./CopyMoveCalendarModal.vue?vue&type=style&index=0&id=96c5a64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c5a64c",
  null
  
)

export default component.exports